export const GROUP_BY = {
  TEAMS: 'teams',
  ROLE: 'role',
  SKILL: 'skill',
} as const;

export type GroupBy = (typeof GROUP_BY)[keyof typeof GROUP_BY];

export const DEFAULT_GROUP_BY: GroupBy = GROUP_BY.TEAMS;
